import { LwpWidgetProviders } from '@revenuewell/widget-legacy-phone';
import { useLocations } from 'apps/wrapper/src/hooks/use-locations';
import { useProductsByLocation } from 'apps/wrapper/src/hooks/use-products-by-location';
import { PropsWithChildren } from 'react';

export const ConditionalLegacyPhoneProviders: React.FC<PropsWithChildren> = ({ children }) => {
  const { selectedLocation } = useLocations();
  const { hasProduct, isLoading: isLoadingProducts } = useProductsByLocation(selectedLocation?.id);
  const enabled = !isLoadingProducts && (hasProduct('phone') || hasProduct('phone1'));

  return enabled ? <LwpWidgetProviders>{children}</LwpWidgetProviders> : <>{children}</>;
};
